import { useState } from 'react';
import styled from '@emotion/styled';
import Terms from '@/pages/Signup/Terms';
import { TermsId } from '@/pages/Signup/termsContent';

import { designSystem } from '@/styles/theme';

interface TermsAgreementProps {
    /** 약관 동의 완료 후 다음 스텝(정보 입력)으로 진행 */
    onNext: () => void;
    // 약관별 동의 상태(7개) 부모로 전달 — 가입 폼에서 API payload에 함께 실어 보낸다.
    onAgreementsChange?: (agreements: Record<TermsId, boolean>) => void;
}

const FormContainer = styled.div`
    width: 100%;
`;

const TermsBox = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;

    @media (max-width: 768px) {
        padding: 16px;
        margin-bottom: 20px;
    }
`;

const NextButton = styled.button<{ disabled?: boolean }>`
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    background: ${props => props.disabled ? '#e5e7eb' : designSystem.colors.primary};
    color: ${props => props.disabled ? '#9ca3af' : '#fff'};
    transition: all 0.3s;

    &:hover:not(:disabled) {
        background: ${designSystem.colors.primaryDark};
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(90, 155, 150, 0.3);
    }

    @media (max-width: 768px) {
        height: 48px;
        font-size: 15px;
    }
`;

const TermsAgreement = ({ onNext, onAgreementsChange }: TermsAgreementProps) => {
    const [isAllAgreed, setIsAllAgreed] = useState(false);

    return (
        <FormContainer>
            <TermsBox>
                <Terms onAllAgreed={setIsAllAgreed} onAgreementsChange={onAgreementsChange} />
            </TermsBox>

            <NextButton
                type="button"
                disabled={!isAllAgreed}
                onClick={onNext}
                title={!isAllAgreed ? '필수 약관에 모두 동의해주세요' : undefined}
            >
                다음
            </NextButton>
        </FormContainer>
    );
};

export default TermsAgreement;
